import axios, {keycloak} from '@/api'

export default {
  fetchGroups({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.get('/admin/service-group/',{params: {limit: 10000, ...payload}})
        .then((response) => {
          commit('SET_GROUPS', response.data.groups)
          resolve(response.data.groups)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  getGroups({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.get('/admin/service-group',{params: payload})
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  storeGroup({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.post('/admin/service-group/', payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  deleteGroup({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.delete('/admin/service-group/'+payload.id+'/')
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  getGroup({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.get('/admin/service-group/'+payload.id)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => { reject(error.response) })
    })
  },
  updateGroup({ commit }, payload){
    return new Promise((resolve, reject) => {
      let url = '/admin/service-group/'+payload.id+'/';
      delete payload.id;

      axios.put(url, payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  assignRoute({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.post('/admin/service-group/'+payload.service_group_id+'/routes/', payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  unassignRoute({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.delete('/admin/service-group/'+payload.id+'/routes/'+payload.route_id+'/')
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
}
